export default "__VITE_ASSET__DXYajPIP__"